<template>
  <b-row class="mb-5">
    <b-col cols="12">
      <b-card style="background: transparent !important" class="card-litigio">
        <template #header>
          <strong class="mb-0">Datos del litigio</strong>
        </template>
        <b-overlay :show="loading" rounded="sm">
          <template #overlay>
            <OverlayButton clase="overlay-md"> </OverlayButton>
          </template>
          <b-row>
            <b-col cols="4" class="mb-4">
              <Input
                label="No. Radicado"
                name="file_number"
                :value="record?.file_number"
                :disabled="true"
              />
            </b-col>
            <b-col cols="4" class="mb-4">
              <Input
                label="Nombre del Demandante"
                name="plaintiff_name"
                :value="record?.plaintiff_name"
                :disabled="true"
              />
            </b-col>
            <b-col cols="4" class="mb-4">
              <Input
                label="Tipo de proceso"
                name="process_type.name"
                :value="record?.process_type?.name"
                :disabled="true"
              />
            </b-col>
            <b-col cols="4" class="mb-4">
              <Input
                label="Ciudad"
                name="city.name"
                :value="record?.city?.name"
                :disabled="true"
              />
            </b-col>
            <b-col cols="4" class="mb-4">
              <Input
                label="Última actualización"
                name="updated_at"
                :value="record?.updated_at"
                :disabled="true"
              />
            </b-col>
            <b-col cols="4" class="mb-4">
              <Input
                label="Riesgo"
                name="risk_type"
                :value="record?.risk_type?.name"
                :disabled="true"
              />
            </b-col>
            <b-col cols="4" class="mb-4">
              <Input
                label="Estado"
                name="status"
                :value="record?.status?.name"
                :disabled="true"
              />
            </b-col>

            <b-col cols="4" class="mb-4">
              <Input
                label="Predicción"
                name="prediction"
                :value="record?.prediction"
                :disabled="true"
              />
            </b-col>
          </b-row>
        </b-overlay>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import useInputs from "@/components/general/Inputs";
const { Input } = useInputs();
export default {
  props: {
    record: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Input,
    OverlayButton,
  },
};
</script>
<style lang="css">
.card-litigio .card-header {
  background: #f5f5f5 !important;
}
</style>
